// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VeeValidate, {Validator} from 'vee-validate'
import ru from 'vee-validate/dist/locale/ru'
import VueAuth from '@websanova/vue-auth'
import axios from 'axios'
import VueAxios from 'vue-axios'
import auth from './auth/jwt.js'
import vbclass from 'vue-body-class'
import vSelect from 'vue-select'
import moment from 'moment'
import store from './store'
import VueRouterUserRoles from "vue-router-user-roles"
import {USER_ROLE_UNREGISTERED} from "./constants"
import Spinner from 'vue-simple-spinner'

Vue.use(VueRouterUserRoles, {router})

Vue.component('vue-simple-spinner', Spinner)
Vue.component('v-select', vSelect)

Vue.config.productionTip = false

Vue.use(vbclass, router)

Vue.use(VeeValidate)
Validator.localize('ru', ru)

Vue.router = router

Vue.use(VueAxios, axios)

Vue.use(VueAuth, {
  auth: auth,
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  authRedirect: {name: 'login'},
  loginData: {url: 'auth/login', method: 'POST', redirect: '/operators', fetchUser: true}, // TODO disable redirect
  fetchData: {url: 'auth/verify', method: 'POST', enabled: true},
  refreshData: {url: 'auth/refresh', method: 'POST', enabled: true, interval: 2}
})

Vue.axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let errorResponse = error.response
    if (errorResponse.status === 401) {
      Vue.auth.logout({
        redirect: {name: 'login'}
      })
    }
    if (errorResponse.status === 500) {
      console.log('Ошибка сервера. Попробуйте позже.')
    }
    return Promise.reject(error)
  }
)

Vue.filter('dateFilter', function (date, formatMask) {
  moment.locale('ru')
  return date ? moment.parseZone(date).format(formatMask) : null
})

Vue.filter('amountFilter', function (amount) {
  return amount ? amount : "\t—"
})

Vue.filter('nullToDashFilter', function (value) {
  return value ? value : "\t—"
})

let getUser = Promise.resolve({role: USER_ROLE_UNREGISTERED})


getUser.then(user => {
  Vue.prototype.$user.set(user)
  new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js